var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFaceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 15.584h-1.416v-1.417a2.125 2.125 0 0 0-2.125-2.125h-4.25a2.125 2.125 0 0 0-2.125 2.125v1.417H2.834v-1.417a3.542 3.542 0 0 1 3.542-3.542h4.25a3.542 3.542 0 0 1 3.541 3.542v1.417zM8.501 9.209a4.25 4.25 0 1 1 0-8.5 4.25 4.25 0 0 1 0 8.5zm0-1.417a2.833 2.833 0 1 0 0-5.667 2.833 2.833 0 0 0 0 5.667z",
    fill: "#8496A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFaceIcon);
export default __webpack_public_path__ + "static/media/ProfileFaceIcon.d09584cbd9afc9d6eeb0b36b0e2047cd.svg";
export { ForwardRef as ReactComponent };